function initPrelaunchSubscribe() {
    const form = document.querySelector('[data-prelaunch-form]');
    if (!form) return;

    const input    = form.querySelector('input[name="email"]');
    const feedback = form.querySelector('[data-prelaunch-feedback]');
    const csrfUrl  = form.getAttribute('action') || '/prelaunch/subscribe';
    const card       = form.closest('.s-zaslepka-before__card');
    const formView   = card && card.querySelector('[data-prelaunch-view="form"]');
    const thanksView = card && card.querySelector('[data-prelaunch-view="thanks"]');

    function showThanks() {
        if (formView && thanksView) {
            formView.hidden = true;
            thanksView.hidden = false;
        } else {
            setFeedback('Dzięki — przypomnimy o starcie!', 'success');
        }
    }

    function setFeedback(message, kind) {
        feedback.textContent = message;
        feedback.classList.remove('is-success', 'is-error');
        if (kind) feedback.classList.add(`is-${kind}`);
    }

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        input.classList.remove('is-invalid');
        setFeedback('', null);

        const email = input.value.trim();
        if (!email) {
            input.classList.add('is-invalid');
            setFeedback('Podaj adres e-mail.', 'error');
            return;
        }

        input.disabled = true;
        try {
            const response = await fetch(csrfUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({ email }),
            });

            console.log(response.status, response.status === 400)

            switch (response.status) {
                case 200:
                    input.value = '';
                    showThanks();
                    return;
                case 400:
                case 403:
                    const data = await response.json();
                    const msg = (data?.errors?.email?.[0]) || 'Niepoprawny adres e-mail.';
                    input.classList.add('is-invalid');
                    setFeedback(msg, 'error');
                    return;
                default:
                    setFeedback('Coś poszło nie tak. Spróbuj ponownie.', 'error');
            }
        } catch {
            setFeedback('Brak połączenia. Spróbuj ponownie.', 'error');
        } finally {
            input.disabled = false;
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrelaunchSubscribe);
} else {
    initPrelaunchSubscribe();
}
